import React from 'react';
import {Tabs} from "antd";
import LoadingIndicator from "../../common/loading/LoadingIndicator";
import connect from "react-redux/es/connect/connect";
import withAuthorization from "../../../services/Authorization";
import {injectIntl} from "react-intl";
import Storage from "../../../services/Storage";
import Constants from "../../../services/Constants";
import WeekConfigurationTab from "./WeekConfigurationTab";

const TabPane = Tabs.TabPane;

class WeekConfiguration extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      planning: {},
      selectedWeekDay: Constants.WEEK_DAY[0]
    }
  }

  componentDidMount(){
    this.props.dispatchFetchPlanningManagement();
  }

  componentWillReceiveProps = (nextProps) => {
    if (nextProps.fetchPlanningManagement && nextProps.fetchPlanningManagement.planningManagement
      && nextProps.fetchPlanningManagement.planningManagement.planning) {
      const planning = nextProps.fetchPlanningManagement.planningManagement.planning || {};
      this.setState({planning});
    }
  };

  save = () => {
    this.props.dispatchSavePlanningManagement({planning: this.state.planning});
  };

  onSelectedWeekDayChange = (weekDay) => {
    this.setState({selectedWeekDay: weekDay});
  };

  onDayPlanningChange = (weekDay, dayPlanning) => {
    const {planning} = this.state;
    planning[weekDay] = dayPlanning;
    this.setState(planning);
  };

  renderWeekDaysTab = () => {
    const {intl:{formatMessage}, fetchMainServices} = this.props;
    const hasTwentyFourSeven = fetchMainServices.mainServices && fetchMainServices.mainServices.offering && fetchMainServices.mainServices.offering.carDropOff;
    const weekDays = [];

    Constants.WEEK_DAY.forEach(weekDay => {
      weekDays.push(
        <TabPane key={weekDay} tab={formatMessage({id: weekDay})}>
          <WeekConfigurationTab data={this.state.planning[weekDay]}
                                weekDay={this.state.selectedWeekDay}
                                onChange={(data) => this.onDayPlanningChange(weekDay, data)}
                                hasTwentyFourSeven={hasTwentyFourSeven || false}
          />
        </TabPane>
      )
    });
    return weekDays;
  };

  renderErrors(errors) {
    const {intl:{formatMessage}} = this.props;
    return Object.keys(errors).map(key => {
      if (errors[key].message === 'error.slot.overlap') {
        return (
          <div key={key}>
            {formatMessage({id: errors[key].message}, {day: formatMessage({id:errors[key].args[0]})})}
          </div>
        )
      }
      if (errors[key].message === 'error.interventions.ongoing') {
        return (
          <div key={key}>
            {formatMessage({id: errors[key].message}, {day: formatMessage({id:errors[key].args[0]}), nbInterventions: errors[key].args[1]})}
          </div>
        )
      }
      return null;
    });
  }

  render() {
    const {intl:{formatMessage}, fetchPlanningManagement, savePlanningManagement} = this.props;
    const user = Storage.getItem('user');
    const canWrite = user.role === 'DUI_ADMIN';
    const error = savePlanningManagement && savePlanningManagement.error;

    return (
      <section className="box week-configuration">
        <header className="box-heading">
          <h2 className="box-heading__title">
            {formatMessage({id:'section.week-configuration.title'})}
          </h2>
          <div className="box-heading__button">
            {canWrite && <button onClick={this.save} type="primary" className="btn btn-sm btn-primary">{formatMessage({id:'action.save'})}</button>}
          </div>
        </header>
        {
          (fetchPlanningManagement.loading) ? (
            <LoadingIndicator/>
          ) : (
            <div className="box__body">
              {error && error.content &&
                <div className="alert alert--error">
                  {this.renderErrors(error.content)}
                </div>
              }
              <Tabs defaultActiveKey={this.state.selectedWeekDay} onChange={this.onSelectedWeekDayChange} type="card">
                {this.renderWeekDaysTab()}
              </Tabs>
            </div>
          )
        }
      </section>
    )
  }
}

const mapStateToProps = state => ({
  fetchPlanningManagement: state.fetchPlanningManagement,
  savePlanningManagement: state.savePlanningManagement,
  fetchMainServices: state.fetchMainServices
});

const mapDispatchToProps = dispatch => ({
  dispatchFetchPlanningManagement: () => dispatch({type: 'FETCH_PLANNING_MANAGEMENT.REQUEST'}),
  dispatchSavePlanningManagement: (body) => dispatch({type: 'SAVE_PLANNING_MANAGEMENT.REQUEST', body}),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withAuthorization(injectIntl(WeekConfiguration), ['DUI_ADMIN', 'DUI_SERVICE_ADVISOR']));



// WEBPACK FOOTER //
// ./src/components/planning/management/WeekConfiguration.js